export default __webpack_public_path__ + "media/images/banners/months/bnr_5-efe8b76ee79e207f47ad8baf47ab4dcb.jpg";